import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GeneradorCarpetaComponent } from "./components/generador-carpeta/generador-carpeta.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "src/app/core/app-routing.module";
import { TooltipModule } from "primeng/tooltip";
import { MultiSelectModule } from "primeng/multiselect";
import { InputSwitchModule } from "primeng/inputswitch";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { DropdownModule } from "primeng/dropdown";
import { TableModule } from "primeng/table";
import { CalendarModule } from "primeng/calendar";
import { ModalFichaTecnicaComponent } from "../obras/components/modal-ficha-tecnica/modal-ficha-tecnica.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalCarpetaEjecutivaComponent } from "./components/modal-carpeta-ejecutiva/modal-carpeta-ejecutiva.component";
import { FormatoPdfCarpetaEjecutivaComponent } from "./components/formato-pdf-carpeta-ejecutiva/formato-pdf-carpeta-ejecutiva.component";
import { AgmCoreModule } from "@agm/core";
import { FormatoPdfCarpetaEjecutivaEstadoComponent } from "./components/formato-pdf-carpeta-ejecutiva-estado/formato-pdf-carpeta-ejecutiva-estado.component";
import { FormatoPdfCarpetaEjecutivaFichaTecnicaComponent } from "./components/formato-pdf-carpeta-ejecutiva-ficha-tecnica/formato-pdf-carpeta-ejecutiva-ficha-tecnica.component";
import { FormatoPdfCarpetaEjecutivaNotaInformativaComponent } from "./components/formato-pdf-carpeta-ejecutiva-nota-informativa/formato-pdf-carpeta-ejecutiva-nota-informativa.component";
import { PdfViewerModule } from "ng2-pdf-viewer";

@NgModule({
  declarations: [
    GeneradorCarpetaComponent,
    ModalCarpetaEjecutivaComponent,
    FormatoPdfCarpetaEjecutivaComponent,
    FormatoPdfCarpetaEjecutivaEstadoComponent,
    FormatoPdfCarpetaEjecutivaFichaTecnicaComponent,
    FormatoPdfCarpetaEjecutivaNotaInformativaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    TableModule,
    DropdownModule,
    ScrollingModule,
    InputSwitchModule,
    MultiSelectModule,
    TooltipModule,
    AppRoutingModule,
    NgbModule,
    AgmCoreModule,
    PdfViewerModule,
  ],
  exports: [
    ModalCarpetaEjecutivaComponent,
    FormatoPdfCarpetaEjecutivaComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarpetaEjecutivaModule {}